import { Injectable } from "@angular/core";
import { Http, Headers, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";

@Injectable()

export class QrCodeService {

    apiUrl: String;
    jwt: String;
    constructor(private http: Http, private appService: AppService) {
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }

    getQrCodeList(filterParams: any) {
        const url = this.apiUrl + 'api/qrcode/list';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(filterParams);
        return this.http.post(url, body, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    generateQrCode(data: any) {
        const url = this.apiUrl + 'api/qrcode/generate';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(data);
        return this.http.post(url, body, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    deleteQrCode(data: any) {
        const url = this.apiUrl + 'api/qrcode/delete';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(data);
        return this.http.post(url, body, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    setUsedQrCode(data: any, status: boolean) {
        const url = this.apiUrl + 'api/qrcode/set-used/' + status;
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(data);
        return this.http.post(url, data, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }
}


// WEBPACK FOOTER //
// /build/client-cms/src/app/qr-code/qr-code.service.ts